// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/preferences/destination_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../core/common_pb";

/**
 * Describes the file proto/model/preferences/destination_preferences.proto.
 */
export const file_proto_model_preferences_destination_preferences = /*@__PURE__*/
  fileDesc("CjVwcm90by9tb2RlbC9wcmVmZXJlbmNlcy9kZXN0aW5hdGlvbl9wcmVmZXJlbmNlcy5wcm90bxIGY2FybWVuIoACChZEZXN0aW5hdGlvblByZWZlcmVuY2VzEisKEnByZWZlcnJlZF9jbGltYXRlcxgBIAMoCzIPLmNhcm1lbi5DbGltYXRlEikKEGF2b2lkZWRfY2xpbWF0ZXMYAiADKAsyDy5jYXJtZW4uQ2xpbWF0ZRIuChRwcmVmZXJyZWRfaWRlb2xvZ2llcxgDIAMoCzIQLmNhcm1lbi5JZGVvbG9neRIsChJhdm9pZGVkX2lkZW9sb2dpZXMYBCADKAsyEC5jYXJtZW4uSWRlb2xvZ3kSMAoPYWR2ZW50dXJvdXNuZXNzGAUgASgOMhcuY2FybWVuLkFkdmVudHVyb3VzbmVzc0IoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z", [file_proto_model_core_common]);

/**
 * Describes the message carmen.DestinationPreferences.
 * Use `create(DestinationPreferencesSchema)` to create a new message.
 */
export const DestinationPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_preferences_destination_preferences, 0);

